module.exports = __webpack_public_path__ + "static/media/iyzico.6dc8df3b.png";